import React from "react";
import { todayInput } from "../model/suiviLivraisonFormat";
import { buttonSecondary, controlStyle, tabButton, tabsBar } from "../styles/suiviLivraisonStyles";
import { FilterShell } from "./SuiviBadges";

// En-tête du suivi : total, onglets patient / livraison, actualisation et filtres de l'onglet actif.

const TABS = [
    { key: "patient", label: "Suivi patient" },
    { key: "livraison", label: "Suivi livraison" },
];

export function SuiviHeader({ total, activeTab, onTabChange, onRefresh, filters }) {
    return (
        <div style={{ padding: "14px 20px 12px", borderBottom: "1px solid #f1f5f9", flexShrink: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px", flexWrap: "wrap" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
                    <span style={{ color: "#0ea5e9", fontSize: "16px", lineHeight: 1 }}>◆</span>
                    <h2 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#0f172a" }}>Suivi</h2>
                    <span style={{ background: "#f1f5f9", color: "#475569", borderRadius: "999px", fontSize: "12px", fontWeight: 600, padding: "2px 9px" }}>
                        {total}
                    </span>
                </div>
                <div style={{ width: 1, height: 24, background: "#e2e8f0", flexShrink: 0 }} />
                <div role="tablist" aria-label="Vues de suivi" style={tabsBar}>
                    {TABS.map(tab => (
                        <button
                            key={tab.key}
                            type="button"
                            role="tab"
                            aria-selected={activeTab === tab.key}
                            onClick={() => onTabChange(tab.key)}
                            style={tabButton(activeTab === tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <div style={{ flex: 1 }} />
                <button onClick={onRefresh} style={buttonSecondary}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                    </svg>
                    Actualiser
                </button>
            </div>
            <SuiviFilters patientTab={activeTab === "patient"} filters={filters} />
        </div>
    );
}

function SuiviFilters({ patientTab, filters }) {
    const { ehpads, tournees, values, setters } = filters;
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
            <FilterShell label="Jour livraison">
                <input type="date" value={values.dateReception} onChange={e => setters.setDateReception(e.target.value)} style={controlStyle} />
            </FilterShell>
            <button type="button" onClick={() => setters.setDateReception(todayInput())} style={buttonSecondary}>Aujourd’hui</button>
            {patientTab && <FilterShell label="Statut">
                <select value={values.statutMode} onChange={e => setters.setStatutMode(e.target.value)} style={controlStyle}>
                    <option value="TOUS">Tous les produits suivis</option>
                    <option value="TRAITE">À livrer</option>
                    <option value="EN_COMMANDE">En commande</option>
                    <option value="EN_RUPTURE">Rupture</option>
                    <option value="LIVRE">Livrés</option>
                    <option value="EN_LIVRAISON">En livraison</option>
                </select>
            </FilterShell>}
            <FilterShell label="EHPAD">
                <select value={values.ehpadId} onChange={e => setters.setEhpadId(e.target.value)} style={controlStyle}>
                    <option value="">Tous</option>
                    {ehpads.map(e => <option key={e.id} value={e.id}>{e.nom || e.code}</option>)}
                </select>
            </FilterShell>
            {patientTab && <FilterShell label="Tournée">
                <select value={values.tournee} onChange={e => setters.setTournee(e.target.value)} style={controlStyle}>
                    <option value="">Toutes</option>
                    {tournees.map(t => <option key={t.id || t.name} value={t.name}>{t.name}</option>)}
                </select>
            </FilterShell>}
            {patientTab && <FilterShell label="Patient">
                <input value={values.patientSearch} onChange={e => setters.setPatientSearch(e.target.value)} placeholder="Nom ou prénom" style={{ ...controlStyle, width: 150 }} />
            </FilterShell>}
            {patientTab && <FilterShell label="Produit">
                <input value={values.produitSearch} onChange={e => setters.setProduitSearch(e.target.value)} placeholder="Médicament" style={{ ...controlStyle, width: 160 }} />
            </FilterShell>}
        </div>
    );
}
